import { expose } from 'comlink';
import messageChannelStore from '@/src/stores/messageChannelStore';
import type { WalletApi } from '../types';
import { type MessageType, SEND_MESSAGE_TYPE } from './messageHandlers';
import { onCallContract } from './onCallContract';
import { onConnectRequest } from './onConnectRequest';
import { onSendRawTransaction } from './onSendRawTransaction';
import { onSignMessage } from './onSignMessage';

export const onInitChannel = (event: MessageEvent<{ type: MessageType }>) => {
  const port = event.ports[0];
  messageChannelStore.getState().setMessagePort(port);
  port.start();

  const api: WalletApi = {
    connect: onConnectRequest,
    signMessage: onSignMessage,
    callContract: onCallContract,
    sendRawTransaction: onSendRawTransaction,
  };

  expose(api, port);

  port.onmessageerror = (_error: MessageEvent) => {
    messageChannelStore.getState().setIsConnected(false);
    messageChannelStore.getState().setMessagePort(null);
  };

  port.postMessage({
    type: SEND_MESSAGE_TYPE.CONNECTED,
  });
  messageChannelStore.getState().setIsConnected(true);
};
